/**
 * SEO 配置 - models (Deutsch)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 - Flaggschiff KI-Videogenerator | WeryAI',
        description: 'Google Veo 3.1: Flaggschiff KI-Videomodell mit nativem Audio.',
        keywords: 'Google Veo 3.1, KI Video, Videogenerator, WeryAI',
    },
    veo_3: {
        title: 'veo 3 KI Video- und Bildgenerierung | WeryAI',
        description: 'Experience veo 3 on WeryAI. High-quality results.',
        keywords: 'veo_3, AI, WeryAI',
    },
    veo_3_fast: {
        title: 'veo 3 fast KI Video- und Bildgenerierung | WeryAI',
        description: 'Experience veo 3 fast on WeryAI. High-quality results.',
        keywords: 'veo_3_fast, AI, WeryAI',
    },
    sora_2: {
        title: 'sora 2 KI Video- und Bildgenerierung | WeryAI',
        description: 'Experience sora 2 on WeryAI. High-quality results.',
        keywords: 'sora_2, AI, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 KI-Videogenerierung | WeryAI',
        description: 'WeryAI Video 1.0 für kinematische KI-Videos.',
        keywords: 'WeryAI Video 1.0, KI Video, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2.0 KI-Bildgenerierung | WeryAI',
        description: 'WeryAI Image 2.0 für Studio-Qualität KI-Bilder.',
        keywords: 'WeryAI Image 2.0, KI Bild, WeryAI',
    },
    image_grok_2: {
        title: 'Grok-2 Bildgenerator - xAI | WeryAI',
        description: 'Erleben Sie Grok-2 von xAI auf WeryAI.',
        keywords: 'Grok-2, xAI, KI Bild, WeryAI',
    },
    kling_ai: {
        title: 'kling ai KI Video- und Bildgenerierung | WeryAI',
        description: 'Experience kling ai on WeryAI. High-quality results.',
        keywords: 'kling_ai, AI, WeryAI',
    },
    runway_ai: {
        title: 'runway ai KI Video- und Bildgenerierung | WeryAI',
        description: 'Experience runway ai on WeryAI. High-quality results.',
        keywords: 'runway_ai, AI, WeryAI',
    },
    hailuo_23: {
        title: 'hailuo 23 KI Video- und Bildgenerierung | WeryAI',
        description: 'Experience hailuo 23 on WeryAI. High-quality results.',
        keywords: 'hailuo_23, AI, WeryAI',
    },
    hailuo_ai: {
        title: 'hailuo ai KI Video- und Bildgenerierung | WeryAI',
        description: 'Experience hailuo ai on WeryAI. High-quality results.',
        keywords: 'hailuo_ai, AI, WeryAI',
    },
    pika_2_2: {
        title: 'pika 2 2 KI Video- und Bildgenerierung | WeryAI',
        description: 'Experience pika 2 2 on WeryAI. High-quality results.',
        keywords: 'pika_2_2, AI, WeryAI',
    },
    seedance: {
        title: 'seedance KI Video- und Bildgenerierung | WeryAI',
        description: 'Experience seedance on WeryAI. High-quality results.',
        keywords: 'seedance, AI, WeryAI',
    },
    wan_2_6: {
        title: 'Wan 2.6 | Fortgeschrittener KI-Video-Generator von Alibaba | WeryAI',
        description: 'Wan 2.6 ist Alibabas neuestes multimodales Flaggschiffmodell zur KI-Videogenerierung – mit kinoreifer 1080p-Qualität, nativer Audio-Video-Synchronisation und intelligenten Multi-Shot-Storytelling-Funktionen. Gratis auf WeryAI testen.',
        keywords: 'Wan 2.6, Alibaba Wan 2.6, KI Video Generator, multimodales Videomodell, Text zu Video, Bild zu Video, Audio-Synchronisation, WeryAI Wan 2.6',
    },
    wan_ai: '',
    image_gpt_4o: {
        title: 'GPT-4o Bildgenerator - OpenAI Native Bild-KI | WeryAI',
        description: 'Generieren Sie KI-Bilder mit GPT-4o. Leistungsstarkes semantisches Verständnis und hochwertige visuelle Ausgabe. Kostenlos auf WeryAI testen.',
        keywords: 'GPT-4o, OpenAI Bild, KI-Kunst, Bildgenerierung, WeryAI',
    },
    image_nano_banana_pro: {
        title: 'Nano Banana Pro - Google Gemini 3.0 Pro Bildgenerierung | WeryAI',
        description: 'Reasoning-basiertes KI-Bildmodell mit 4K-Qualität.',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, KI Bildgenerierung, WeryAI',
    },
    image_nano_banana: {
        title: 'Google Nano Banana - Gemini 2.5 Flash Schnellzeichnen | WeryAI',
        description: 'Ultraschneller KI-Bildgenerator von Google DeepMind.',
        keywords: 'Nano Banana, Gemini 2.5 Flash, Schnellzeichnen, WeryAI',
    },
    image_flux: {
        title: 'FLUX AI Bildgenerator - Open-Source-Modell | WeryAI',
        description: 'FLUX vom Stable Diffusion Team. Hervorragende visuelle Qualität.',
        keywords: 'FLUX, AI, Bildgenerierung, WeryAI',
    },
    image_flux_kontext: {
        title: 'FLUX.1 Kontext - Professionelle KI-Zeichnungsverbesserung | WeryAI',
        description: 'FLUX.1 Pro und Max mit verbessertem Text-Rendering.',
        keywords: 'FLUX Kontext, FLUX Pro, FLUX Max, WeryAI',
    },
    image_imagen: {
        title: 'Google Imagen 4 - Text-zu-Bild Diffusionsmodell | WeryAI',
        description: 'Generieren Sie fotorealistische und künstlerische Bilder mit Google Imagen 4.',
        keywords: 'Imagen 4, Google AI, Diffusion, WeryAI',
    },
    image_qwen_image: {
        title: 'Qwen Image - Alibaba Text-Rendering-Modell | WeryAI',
        description: 'Alibaba KI-Bildmodell für mehrsprachiges Text-Rendering.',
        keywords: 'Qwen Image, Alibaba, Text-Rendering, WeryAI',
    },
    image_wan_ai: {
        title: 'Wan 2.5 Bildgenerierung - High-Fidelity-Modell | WeryAI',
        description: 'Wan 2.5 mit präziser Prompt-Verfolgung und fotografischem Rendering.',
        keywords: 'Wan AI, Wan 2.5, Bildgenerierung, WeryAI',
    },
    image_seendream: {
        title: 'Seedream 4.0 - ByteDance 4K-Batch-Zeichenmodell | WeryAI',
        description: 'Ultraschnelles Zeichenmodell von ByteDance mit Batch-Verarbeitung.',
        keywords: 'Seedream, ByteDance, 4K Zeichnen, WeryAI',
    },
    image_dreamina: {
        title: 'Dreamina 4.0 - ByteDance KI-Bilderstellungsmodell | WeryAI',
        description: 'Dreamina 4.0 für Skizze-zu-Bild-Konvertierung.',
        keywords: 'Dreamina 4.0, ByteDance, KI-Bilderstellung, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Seedream 4.5 - ByteDance Flaggschiff KI-Bildgenerierungsmodell | WeryAI',
        description: 'Seedream 4.5 ist ByteDances neuestes Flaggschiff-KI-Bildmodell mit Fokus auf präzisem Typografie-Rendering und Multi-Bild-Fusion mit 4K Ultra-HD-Ausgabe. Kostenlos auf WeryAI testen.',
        keywords: 'Seedream 4.5, KI-Bildgenerierung, Typografie-Rendering, Bildfusion, ByteDance, 4K-Qualität, WeryAI',
    },
    image_midjourney: {
        title: 'Midjourney - Flexible, detaillierte und lebendige Bildgenerierung | WeryAI',
        description: 'Midjourney ist ein Flaggschiff-KI-Bildmodell eines unabhängigen Forschungslabors, bekannt für seine künstlerische Ästhetik. Testen Sie es kostenlos auf WeryAI.',
        keywords: 'Midjourney, KI-Bildgenerierung, künstlerische Kreation, Beleuchtungsqualität, Text-Rendering, hyperrealistische Porträts, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 KI-Video-Generator - Kinoreife Videos erstellen | WeryAI',
        description: 'Erstellen Sie beeindruckende Videos mit Runway Gen-4.5 auf WeryAI. Autoregressive-Diffusion-Hybridarchitektur für präzise Physiksimulation und zeitliche Konsistenz.',
        keywords: 'Runway Gen-4.5, KI-Video-Generator, kinoreifes KI-Video, Physiksimulation, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro KI-Video-Generator - Hochwertige Videoerstellung | WeryAI',
        description: 'Generieren Sie hochwertige Videos mit Kling 2.6 Pro auf WeryAI. Native audiovisuelle Generierung, kinoreife 1080p-Qualität, hervorragende Prompt-Befolgung.',
        keywords: 'Kling 2.6 Pro, KI-Video-Generator, hochwertiges KI-Video, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 Video-Generator - Präzise Kamerasteuerung und Frame-Führung | WeryAI',
        description: 'Generieren Sie kinoreife KI-Videos mit Dreamina 3.0 (Jimeng 3.0) auf WeryAI. Präzise Start/End-Frame-Steuerung, professionelle Kamerabewegungen und 1080p-Hochdynamik-Videogenerierung.',
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, KI-Video-Generator, Kamerasteuerung, Start-End-Frame, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 KI-Video-Generator - Kreative Videogenerierung | WeryAI',
        description: 'Entfesseln Sie Ihre Kreativität auf WeryAI mit dem Kling O1 KI-Video-Generator. Perfekt für die Generierung fantasievoller und einzigartiger Videoinhalte.',
        keywords: 'Kling O1, KI-Video-Generator, kreatives KI-Video, Kling AI, WeryAI',
    },
}
